import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {GetService} from "../../core/get.service";
import {Subject} from "rxjs";
import {Router} from "@angular/router";
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.less'],
})

export class InvoicesComponent implements OnInit {
    public allSelected: Boolean = false;
    @HostListener('document:scroll', ['$event'])
    onWindowScroll() {
        if (
            $(window).scrollTop() >=
            $(document).height() - $(window).height() - 100
        ) {
            // this.addNewData(this.invoices);
        }
    }

    public pagination = {
        inProgress: true as boolean,
        nextPage: 'x' as string,
    };
    public isRequestInProgress = true;
    public limit = 10;

    public invoices: Invoices;

    constructor(public getService: GetService, private router: Router) {
    }

    ngOnInit(): void {
        this.getService.getUser().then(res => {
                const user = res
                if (user.roles[0].id === 1) {
                    this.getInvoices()
                }
            }, err => {
            }
        );
    }

    hasPage (data: any, limit: boolean) {
        if (limit) {
            if (data.length < this.limit) {
                this.pagination.nextPage = ''
            }
        } else {
            if (data.length === 0) {
                this.pagination.nextPage = ''
            }
        }
    }

    getInvoices(id?: string) {
        return this.getService.getAllInvoices(id).then(res => {

                this.pagination.inProgress = false
                this.isRequestInProgress = false

                this.invoices = res

                this.hasPage(res,true)
            }, err => {
            }
        );
    }

    addNewData(items: any) {
        const first = this.invoices[this.invoices.length - 1]
        if (first && first.id) {
            this.pagination.inProgress = true
            this.getService.getAllInvoices(first.id).then(res => {
                res.forEach((item: any) => {
                    items.push(item);
                });

                this.pagination.inProgress = false

                this.hasPage(res, true)
            }, err => {
            });
        }
    }

    validDate(timestamp: number) {
        const valid = (new Date(timestamp)).getTime() > 0;
        if (valid) {
            const a = new Date(timestamp * 1000),
                month = (a.getMonth() + 1);

            const timeMonth = ((month < 10) ? `0${month}` : `${month}`);

            switch (environment.dateFormat) {
                case 'MM/dd/yyyy':
                    return `${timeMonth}/${a.getDate()}/${a.getFullYear()}`;
                case 'dd/MM/yyyy':
                default:
                    return `${a.getDate()}/${timeMonth}/${a.getFullYear()}`;
            }
        } else {
            return '-';
        }
    }

    totals(amount: number) {
        return (amount / 100)
    }

    goToProfile() {
        this.router.navigateByUrl('/profile');
    }

    goToInfo() {
        this.router.navigateByUrl('/info');
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/invoices/invoices.component.ts